import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { BASE_URLS, ITCILogHistoryRequest, ITCILogResponse, SERVICE_URLS, TCI_LOG_QUERY_PARAMS, TCI_QUERY_STYLES } from "@tci/common";
import { Observable } from "rxjs";

@Injectable()
export class BaseAppDetailElasticLogsService {
    constructor(private http: Http) {

    }

    fetchLogs(input: ITCILogHistoryRequest): Observable<ITCILogResponse> {
        let baseUrl = `${SERVICE_URLS.ELASTIC_LOGS}/fetchLogs`;

        baseUrl += `?${TCI_LOG_QUERY_PARAMS.app_id + "=" + input.appId}`;
        baseUrl += `${(input.startRow !== undefined) || (input.startRow !== null) ?
            "&" + TCI_LOG_QUERY_PARAMS.start_row + "=" + input.startRow : ""}`;
        baseUrl += `${input.fetchSize ? "&" + TCI_LOG_QUERY_PARAMS.fetch_size + "=" + input.fetchSize : ""}`;
        baseUrl += `${input.style ? "&" + TCI_LOG_QUERY_PARAMS.style + "=" + input.style : ""}`;
        baseUrl += `${input.timeSlot ? "&" + TCI_LOG_QUERY_PARAMS.time_slot + "=" + input.timeSlot : ""}`;
        baseUrl += `${input.startTime ? "&" + TCI_LOG_QUERY_PARAMS.start_time + "=" + input.startTime : ""}`;
        baseUrl += `${input.endTime ? "&" + TCI_LOG_QUERY_PARAMS.end_time + "=" + input.endTime : ""}`;

        return this.http.get(baseUrl)
            .map(res => <ITCILogResponse>res.json())
            .catch(err => Observable.throw(err));
    }
}
